export const ACCESS_TOKEN_KEY = 'accessToken';
export const REFRESH_TOKEN_KEY = 'refreshToken';
export const CURRENCY = 'BYN';
export const WARNING = 'vitaemWarning';
export const TARIF_ORDER = 'tarifOrder';
export const TARIF = 'vitaemTarif';

export const SUBMONTHS_FROM_TODAY_FOR_CHECKERBOARD = 2;
export const ADDMONTHS_FROM_TODAY_FOR_CHECKERBOARD = 12;

// REGEXP

export const NAME_REG = /^[A-Za-z]+(-[A-Za-z]+)?$|^[А-ЯЁа-яё]+(-[А-ЯЁа-яё]+)?$/;
export const MIDDLENAME_REG = /^([A-Za-z]+)$|^([А-ЯЁа-яё]+)$/;
export const EMAIL_REG =
  /^([a-zA-Z0-9_-]+\.)*[a-zA-Z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$/;
export const TELEGRAM_REG = /^(?:@?[A-Za-z0-9_\s/]){5,32}$/;
// /^(?![0-9_])[a-zA-Z][a-zA-Z0-9_]{4,31}$/

// //^(?:@?[A-Za-z0-9_]{4,31})$

export const FACEBOOK_REG = /^(?=.*[a-zA-Zа-яА-Я])[\wа-яА-Я!?@ ]{5,}$/;

export const INSTAGRAM_REG =
  /^(?=.{3,30}$)(?!.*[^\wа-яА-Я.-])(?!^[._-])(?!.*[._-]{2})[a-zA-Zа-яА-Я0-9][\wа-яА-Я.-]*[a-zA-Zа-яА-Я0-9]$/;

export const VKONTAKTE_REG =
  /^(?=.{5,101}$)(?!.*[-'\s]{2})[а-яА-Яa-zA-Z][а-яА-Яa-zA-Z'-]{1,49}\s[а-яА-Яa-zA-Z][а-яА-Яa-zA-Z'-]{1,49}$/;
export const URL_REG =
  /^http(s)?:\/\/([0-9a-zа-яё]+[~_\.-]?[0-9a-zа-яё]+)+\.([a-zа-яё]{2,6})\/?$/;
export const OBJECT_NAME_REG = {
  isLetter: /[A-Za-zА-ЯЁа-яё]/,
  length:
    /^[A-Za-zА-ЯЁа-яё0-9\s!\?@#\$%\^&\*\(\)\[\]{}<>,\._'\+=\|\/\\"„“«»‘’`~”:;§€£©®™°•¢№-]{3,60}$/,
};
export const ADDRESS_REG = {
  isLetter: /[A-Za-zА-ЯЁа-яё]/,
  length:
    /^[A-Za-zА-ЯЁа-яё0-9\s!\?@#\$%\^&\*\(\)\[\]{}<>,\._'\+=\|\/\\"„“«»‘’`~”:;§€£©®™°•¢№-]{3,60}$/,
};
export const FEATURE_NAME_REG = {
  isLetter: /[A-Za-zА-ЯЁа-яё]/,
  length:
    /^[A-Za-zА-ЯЁа-яё0-9\s!\?@#\$%\^&\*\(\)\[\]{}<>,\._'\+=\|\/\\"„“«»‘’`~”:;§€£©®™°•¢№-]{0,30}$/,
};
export const ROOM_NAME_REG = {
  isLetter: /[A-Za-zА-ЯЁа-яё]/,
  length:
    /^[A-Za-zА-ЯЁа-яё0-9\s!\?@#\$%\^&\*\(\)\[\]{}<>,\._'\+=\|\/\\"„“«»‘’`~”:;§€£©®™°•¢№-]{0,50}$/,
};
export const PASS_REG = {
  isUppercaseLetter: /[A-Z]/,
  isLowercaseLetter: /[a-z]/,
  isDigit: /[0-9]/,
  isSymbol: /[!\?@#\$%\^&\*\(\)\[\]{}<>,\._'\+=\|\/"-]/,
  minLength: /^[A-Za-z0-9!\?@#\$%\^&\*\(\)\[\]{}<>,\._'\+=\|\/"-]{8,}$/,
};
export const POSITION_REG = {
  isLetter: /[A-Za-zА-ЯЁа-яё]/,
  length:
    /^[A-Za-zА-ЯЁа-яё0-9\s!\?@#\$%\^&\*\(\)\[\]{}<>,\._'\+=\|\/"-]{3,50}$/,
};

export const COORDINATES_REG = /^d{2}.d{5,6}$/;

// Olya
export const IND_TAXPAYER_NUMBER_REG = {
  isDigit: /[0-9]/,
  length: /^[(A-Z0-9]{7,14}$|^[0-9]{7,14}$/,
};
export const ENT_TAXPAYER_NUMBER_REG = /^[0-9]{8,14}$/;

export const ANIMAL_INFO_REG = {
  isLetter: /[A-Za-zА-ЯЁа-яё]/,
  length:
    /^[A-Za-zА-ЯЁа-яё0-9\s!\?@#\$%\^&\*\(\)\[\]{}<>,\._'\+=\|\/"-]{0,100}$/,
};

// ERRORS

const getFieldError = (fieldName: string) => {
  return `${fieldName} не соответствует рекомендациям, указанным в подсказке`;
};

export const REQUIRED_FIELD_ERROR = 'Поле обязательно для заполнения';
export const REQUIRED_FIELD_ERROR2 = 'Обязательное поле';

export const FIRST_NAME_ERROR = getFieldError('Имя');
export const LAST_NAME_ERROR = getFieldError('Фамилия');
export const MIDDLE_NAME_ERROR = getFieldError('Отчество');

export const EMAIL_ERROR = 'Не соответствует формату электронной почты';
export const EMAIL_ALREADY_EXISTS_ERROR =
  'Пользователь с таким адресом уже существует';

export const TELEPHONE_ERROR = 'Не соответствует формату мобильного телефона';
export const CONTACTPHONE_ERROR = 'Не соответствует формату телефонного номера';
export const OBJECT_NAME_ERROR = getFieldError('Название объекта');
export const URL_ERROR = 'Не соответствует формату адреса сайта';
export const COORDINATES_ERROR = 'Не соответствует формату GPS координат';

export const PASS_ERROR = getFieldError('Пароль');
export const CONFIRM_PASS_ERROR = 'Пароли не совпадают';
export const CREDENTIALS_ERROR =
  'Пользователь с такой электронной почтой или паролем не найден';

export const POSITION_ERROR = getFieldError('Должность');

export const REGION_ERROR = getFieldError('Административное деление');
export const LOCALITY_ERROR = getFieldError('Название населенного пункта');
export const ADDRESS_ERROR = getFieldError('Адрес');

export const IMAGE_ERROR =
  'Фото не соответствует рекомендациям, указанным в подсказке';

export const INVALID_CODE_ERROR =
  'Введен неверный код активации. Проверьте код и введите снова';
export const EXPIRED_CODE_ERROR =
  'Срок действия кода истек. Для генерации нового кода активации нажмите на кнопку “Получить код еще раз”';

export const RENTAL_DESCRIPTION_ERROR = getFieldError('Текстовое описание');
export const FEATURE_NAME_ERROR = getFieldError('Наименование удобства');

export const ROOM_NAME_ERROR = getFieldError('Название комнаты');
export const NUMBER_VALUE_ERROR = 'Значение должно быть больше 0';

export const TAXPAYER_NUMBER_ERROR = getFieldError('Номер налогоплательщика');
export const ENTITY_NAME_ERROR = getFieldError('Наименование');

export const TOTAL_INFO_ERROR =
  'Не соответствует рекомендациям, указанным в подсказке';

// REQUIREMENTS

export const FIRST_NAME_REQ = [
  'Имя должно содержать русские или латинские буквы и состоять из одного слова.',
  'Если у вас двойное имя, допускается использование «-» без пробелов, например Анна-Мария.',
  'Максимальное количество символов - 60.',
];
export const LAST_NAME_REQ = [
  'Фамилия должна содержать русские или латинские буквы и состоять из одного слова.',
  'Если у вас двойная фамилия, допускается использование «-» без пробелов, например Римский-Корсаков.',
  'Максимальное количество символов - 60.',
];
export const MIDDLE_NAME_REQ = [
  'Отчество должно содержать русские или латинские буквы.',
  'Максимальное количество символов - 60.',
]; // ?
export const URL_REQ =
  'Укажите точный адрес своего ресурса с корректным префиксом (http:// или https://)';
export const PASS_REQ = [
  'Пароль должен состоять минимум из 8-и символов.',
  'Содержать латинские буквы верхнего и нижнего регистра, цифры и спецсимволы.',
  'В пароле должны быть минимум 1 цифра, 1 заглавная буква, 1 строчная буква, 1 спецсимвол (!?@#$%^&*()[]{}<>,._\'-+=|/")',
];
export const FEEDING_ADULT_REQ = [
  'Введите стоимость приема пищи для 1 человека',
  'При активном чекбоксе стоимость обязательна',
  'Максимальное значение 99999.99',
  'При расчете общей суммы за бронь к стоимости проживания будет добавлена стоимость питания в расчете на каждого туриста',
];
export const FEEDING_KIDS_REQ = [
  'Можно ввести стоимость питания для детей до 18 лет',
  'Для детей можно установить цены только на те приемы пищи, которые указаны выше в общей настройке',
  'Можно указать возраст, для детей младше которого питание будет бесплатным',
];
export const KIDS_AGES_REQ = [
  'Возраст конца диапазона должен быть больше, чем возраст начала диапазона',
];
const getFieldReq = (
  isMaxOnly: boolean,
  fieldName: string,
  maxLength: string,
  minLength?: string,
) => {
  return [
    `${fieldName} содержать русские и/или латинские буквы, а также может содержать цифры и спецсимволы.`,
    isMaxOnly
      ? `${fieldName} состоять максимум из ${maxLength} символов, включая пробелы.`
      : `${fieldName} состоять минимум из ${minLength} символов и максимум из ${maxLength}, включая пробелы.`,
  ];
};
export const OBJECT_NAME_REQ = getFieldReq(
  false,
  'Название должно',
  '60-ти',
  '3-х',
);
export const POSITION_NAME_REQ = getFieldReq(
  false,
  'Должность должна',
  '50-ти',
  '3-х',
);
export const REGION_REQ = getFieldReq(
  false,
  'Административное деление должно',
  '60-ти',
  '3-х',
);
export const LOCALITY_REQ = getFieldReq(
  false,
  'Название населенного пункта должно',
  '60-ти',
  '3-х',
);
export const ADDRESS_REQ = getFieldReq(false, 'Адрес должен', '60-ти', '3-х');
export const ROOM_NAME_REQ = getFieldReq(true, 'Название должно', '50-ти');

export const MAIN_OBJECT_IMAGE_REQ = [
  'Формат изображения .jpg, .jpeg, допускается .png',
  'Размер файла не более 2 Мб',
  'Максимальная длина изображения 2000px',
  'Максимальная высота изображения 2000px',
];

export const RENTAL_DESCRIPTION_REQ = [
  'Русские/латинские буквы',
  'Допускаются цифры и спецсимволы',
  'Максимальное количество символов - 10000, включая пробелы',
];
export const SHORT_DESCRIPTION_REQ = [
  'Русские/латинские буквы',
  'Допускаются цифры и спецсимволы',
  'Максимальное количество символов - 200, включая пробелы',
];
export const FEATURE_NAME_REQ = [
  'Наименование удобства должно содержать русские и/или латинские буквы, а также может содержать цифры и спецсимволы',
  'Максимальное количество символов - 30, включая пробелы',
];

export const IND_TAXPAYER_NUMBER_REQ = [
  'Латинские заглавные буквы допускаются',
  'Заполнение поля только заглавными латинскими буквами не допускается',
  'Спецсимволы не допускаются',
  'Цифры допускаются',
  'Общее количество символов 7-14',
];
export const ENT_TAXPAYER_NUMBER_REQ = ['Номер должен содержать 8-14 цифр'];

export const AVATAR_REQ = [
  'Формат изображения .jpg, .jpeg, .png',
  'Размер файла не более 1 Мб',
];
export const ANIMALINFO_REQ = [
  'Допускаются буквы',
  'Допускаются цифры и спецсимволы',
  'Максимальное количество символов - 100',
];
export const TELEGRAM_REQ = [
  'Латинские буквы в верхнем и нижнем регистре, символ _ (но не в начале)',
  'Начинаться может с символа @',
  'Цифры допускаются',
  'Количество символов не считая @ - от 5 до 32',
];
export const COMMENT_REQ = [
  'Допускаются буквы',
  'Допускаются цифры и спецсимволы',
  'Максимальное количество символов - 550',
];
export const RENTAL_OBJECT_IMAGES_REQ = [
  'Максимальное количество загружаемых фото - 20',
  'Формат изображения .jpg, .jpeg, допускается .png',
  'Размер файла не более 2 Мб',
  'Максимальная длина изображения 2000px',
  'Максимальная высота изображения 2000px',
];

export const RULES_PDF_FILE_REQ = [
  'Допустимый формат файла - .pdf',
  'Размер файла не более 5 Мб',
];

// TIME

export const TIME_CODE_CONFIRMATION_SENDING = 60;
export const TIME_BLOCK_USER = 20;

// Olya
export const TaxPayerNumberList = [
  { value: 'by', label: 'Введите УНП' },
  { value: 'ru', label: 'Введите ИНН' },
  { value: 'ua', label: 'Введите ИНН' },
  { value: 'kz', label: 'Введите ИИН' },
  { value: 'am', label: 'Введите УНН/НЗОУ' },
  { value: 'az', label: 'Введите ИНН/ПИК' },
  { value: 'ge', label: 'Введите номер VAT' },
  { value: 'kg', label: 'Введите ИНН' },
  { value: 'md', label: 'Введите ИНФ (IDNP)/ ФК, присвоенный ГНС' },
  { value: 'tj', label: 'Введите ИНН' },
  { value: 'uz', label: 'Введите ИНН' },
  { value: 'lv', label: 'Введите ПК (TIN)' },
  { value: 'lt', label: 'Введите ИН' },
  { value: 'ee', label: 'Введите УЛК' },
  { value: 'pl', label: 'Введите номер NIP' },
];
export const EntityTaxNumberList = [
  { value: 'by', label: 'Введите УНП' },
  { value: 'ru', label: 'Введите ИНН' },
  { value: 'ua', label: 'Введите ИНН' },
  { value: 'kz', label: 'Введите БИН' },
  { value: 'am', label: 'Введите УНН' },
  { value: 'az', label: 'Введите ИНН' },
  { value: 'ge', label: 'Введите номер VAT' },
  { value: 'kg', label: 'Введите ИНН' },
  { value: 'md', label: 'Введите ГИН (IDNO)' },
  { value: 'tj', label: 'Введите ЕИН' },
  { value: 'uz', label: 'Введите ИНН' },
  { value: 'lv', label: 'Введите РН' },
  { value: 'lt', label: 'Введите ИНП' },
  { value: 'ee', label: 'Введите РК' },
  { value: 'pl', label: 'Введите номер NIP' },
];

// MASKS

export const priceMask = {
  mask: Number,
  scale: 2,
  signed: false,
  thousandsSeparator: ' ',
  padFractionalZeros: true,
  unmask: true,
  min: 0.0,
  max: 999999999.99,
};
export const summMask = {
  mask: Number,
  scale: 2,
  signed: false,
  thousandsSeparator: ' ',
  padFractionalZeros: true,
  unmask: true,
  min: -999999999.99,
  max: 999999999.99,
};

export const percentageMask = {
  mask: Number,
  scale: 0,
  signed: false,
  thousandsSeparator: '',
  unmask: true,
  min: 0,
  max: 100,
};
export const kidsAgeMask = {
  mask: Number,
  scale: 0,
  signed: false,
  thousandsSeparator: '',
  unmask: true,
  min: 0,
  max: 17,
};

export const latitudeMask = {
  mask: Number,
  scale: 6,
  signed: true,
  min: -90.0,
  max: 90.0,
  unmask: true,
  thousandsSeparator: '',
  padFractionalZeros: true,
};

export const longitudeMask = {
  mask: Number,
  radix: '.',
  scale: 6,
  signed: true,
  min: -180.0,
  max: 180.0,
  thousandsSeparator: '',
  padFractionalZeros: true,
  unmask: true,
};

export const closureReason = [
  { value: 'to', label: 'Техообслуживание' },
  { value: 'rn', label: 'Ремонт' },
  { value: 'ow', label: 'Для своих' },
];

//error massage
export const APP_ERROR = `Извините за неудобства! 
Сейчас мы работаем над устранением небольшой технической неполадки. 
Спасибо за ваше терпение. 
Пожалуйста, попробуйте обновить страницу или вернуться позже.`;
